import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import NotFound from "./pages/NotFound";
import ProductsHomePage from "./pages/products-home-page";
import ProductsPage from "./pages/products"; // Import the new ProductsPage
import UserAccountPage from "./pages/user-account-page";
import ApiDocumentationPage from "./pages/api-documentation-page";
import SkinPassportPage from "./pages/skin-passport-page";
import ProductProfilePage from "./pages/product-profile-page";
import PricesPage from "./pages/prices-page";
import AuthPage from "./pages/auth-page"; // Import the new AuthPage
import TermsPage from "./pages/terms-page"; // Import the new TermsPage
import PrivacyPolicy from "./pages/privacy-policy-page"; // Import the new PrivacyPolicy
import CookiePolicy from "./pages/cookie-policy-page"; // Import the new CookiePolicy
import TestPage from "./pages/TestPage"; // Import the new TestPage
import TestPage2 from "./pages/TestPage2"; // Import the new TestPage
import BrandPage from './pages/brand-page/BrandPage';
import ForBusinessPage from './pages/for-business-page'; // Import the new ForBusinessPage
import About from './pages/About'; // Import the new About page
import OurTeam from './pages/OurTeam'; // Import the new OurTeam page
import Jobs from './pages/Jobs'; // Import the new Jobs page
import TestPage3 from './pages/TestPage3'; // Import the new TestPage3
import Recommendations from "./pages/Recommendations"; // Import the new Recommendations page
import Accessibility from "./pages/accessibility-page"; // Import the Accessibility page
import LearnMorePage from "./pages/learn-more-page"; // Import the new LearnMorePage

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your routes here */}
          <Route path="/" element={<ProductsHomePage />} />
          <Route path="/products-home-page" element={<ProductsHomePage />} />
          <Route path="/products" element={<ProductsPage />} /> {/* Add route for /products */}
          <Route path="/user-account-page" element={<UserAccountPage />} />
          <Route path="/api-documentation-page" element={<ApiDocumentationPage />} />
          <Route path="/skin-passport" element={<SkinPassportPage />} />
          <Route path="/products/:productId" element={<ProductProfilePage />} />
          <Route path="/prices" element={<PricesPage />} />
          <Route path="/auth" element={<AuthPage />} /> {/* Add route for /auth */}
          <Route path="/terms" element={<TermsPage />} /> {/* Add route for /terms */}
          <Route path="/privacy" element={<PrivacyPolicy />} /> {/* Add route for /privacy */}
          <Route path="/cookies" element={<CookiePolicy />} /> {/* Add route for /privacy */}
          <Route path="/test" element={<TestPage />} /> {/* Add route for /test */}
          <Route path="/test2" element={<TestPage2 />} /> {/* Add route for /test */}
 <Route path="/brand" element={<BrandPage />} />
 <Route path="/test3" element={<TestPage3 />} />
 <Route path="/about" element={<About />} />
 <Route path="/for-business" element={<ForBusinessPage />} />
 <Route path="/our-team" element={<OurTeam />} />
 <Route path="/jobs" element={<Jobs />} />
 <Route path="/recommendations" element={<Recommendations />} /> {/* Add route for /recommendations */}
 <Route path="/accessibility" element={<Accessibility />} /> {/* Add route for /accessibility */}
 <Route path="/learn-more" element={<LearnMorePage />} /> {/* Add route for /learn-more */}

          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;